import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Pagination, Table as TB } from "../../../components";
import Filter from "./Filter/Filter";
import { CheckUserAgent, formatDate, formatDateToTime, formatDB, sorterArray } from "../../../utils";
import axiosClient from "../../../services/axiosClient";
import styles from "./Error.module.css";
import NameCol from "../../../components/NameCol";
import Nodata from "../NoData/Nodata";

const cx = classNames.bind(styles);
const Error = () => {
  const [error, setError] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [textSearch, setTextSearch] = useState();
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };
  const onChangeTextSearch = (data) => {
    setTextSearch(data);
    setCurrentPage(1)
  };
  useEffect(() => {
    async function getHistoryError() {
      const date =
        startDate && endDate
          ? {
            day_start: formatDB(startDate),
            day_end: formatDB(endDate),
          }
          : {};
      const res = await axiosClient.get("/errorHistory/get-list-error-history/", {
        params: {
          page: currentPage,
          size: 10,
          ...date,
          username: textSearch,
          action_code: "CODE_5"
        },
      });
      if (res.count) {
        setPages(Math.ceil(res.count / 10));
      } else {
        setPages(1);
      }
      setError(res.data);
    }
    getHistoryError();
  }, [currentPage, textSearch, endDate, startDate]);
  const onChangeDateStart = (data) => {
    setStartDate(data);
  };
  const onChangeDateEnd = (data) => {
    setEndDate(data);
  };

  useState(() => {
    const dateNow = new Date()
    const time = formatDate(dateNow)
    setStartDate(time);
    setEndDate(time)
  }, [])

  useEffect(() => {
    const newData = error.length > 0 ? [...error] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [error, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }


  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      date: formatDateToTime(item.TIME),
      username: item.USERNAME,
      action: item?.ERROR,
      device: CheckUserAgent(item?.USER_AGENT),
      error_code: item?.STATUS
    };
  });

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Tài khoản'} handleSort={handleSort} method={'USERNAME'} />,
      key: "username",
    },
    {
      label: <NameCol active={method} title={'Hành động'} handleSort={handleSort} method={'ERROR'} />,
      key: "action",
    },
    {
      label: <NameCol active={method} title={'Thiết bị'} handleSort={handleSort} method={'USER_AGENT'} />,
      key: "device",
    },
    {
      label: <NameCol active={method} title={'Mã lỗi'} handleSort={handleSort} method={'STATUS'} />,
      key: "error_code",
    },
    {
      label: <NameCol active={method} title={'Thời gian'} handleSort={handleSort} method={'TIME'} />,
      key: 'date'
    },
  ];
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Lịch sử lỗi</h1>
      </div>
      <div className={cx('content')}>
        <Filter
          changeTextSearch={onChangeTextSearch}
          dayStart={startDate}
          dayEnd={endDate}
          onChangeDayStart={onChangeDateStart}
          onChangeDayEnd={onChangeDateEnd}
        />
        <TB data={dataSource} colum={columns} />
        {dataSource?.length > 0 ?  <div className={cx("pagination")}>
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            pages={pages}
            currentPage={currentPage}
          />
        </div>:<Nodata/>}
      </div>
    </>
  );
};

export default Error;
